module.exports = __webpack_public_path__ + "static/media/chair-office.285ae922.svg";